export const Regex = {
  /**
   * 数字、字母、下划线至少2种，8-20位
   */
  // password: /^[a-zA-Z_\d](?![\d]+$)(?![a-zA-Z]+$)(?!_+$)[a-zA-Z_\d]{8,20}$/,
  /**
   * 数字、字母、下划线至少4种，8-20位
   */
  /* eslint-disable-next-line no-useless-escape */
  password: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=(?:.*?[!"#$%&'()*+,-./:;<=>?@\[\]^_`{|}~\\]))[a-zA-Z0-9!"#$%&'()*+,-./:;<=>?@\[\]^_`{|}~\\]{8,20}$/,
  mobile: /^1[3-9][\d]{9}$/,
  smsVerifyCode: /^[\d]{1,6}$/,
  // 图形验证码
  // imageVerifyCode:
  // 身份证号
  idcard: /(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}[0-9Xx]$)/,
}

export const tableColumnWidth = {
  /**准入编号、融资单编号、还款单编号 [10位：A+YYMMDD+3位自增数字序号。当达到A230310999后自动升位]*/
  NO_10: '138px',
  /** 客户编号/买方客户编号/企业编号、客户外部编号 [8位：CM+6位顺序数值|8位：ET+6位顺序数值，演示环境同客户编号，实际交付以对侧要求为准]*/
  NO_8: '126px',
  /**资金甬道编号 [20位：字母/数字/符号组合]*/
  NO_20: '342px',
  /**转账申请单号/业务编号、合同编号 [11位：T+YYMMDD+4位自增数字序号，当达到T2303109999后自动升位，演示环境自增数字序号控制在9999之内|11位：C+YYMMDD+自增数字序号位，当达到C2303109999后自动升位，演示环境自增数字序号控制在9999之内] */
  NO_11: '147px',
  /**标的物编号（采购、应收）[20位：2位业务线首字母缩写+YYMMDD+12位自增数字序号] */
  SUBJECT_NO_20: '234px',
  /**日期 [YYYY-MM] */
  DATE_Y_M: '107px',
  /**日期 [YYYY-MM-DD] */
  DATE_Y_M_D: '136px',
  /**日期 [YYYY-MM-DD HH:MM:SS] */
  DATE_Y_M_D_HMS: '202px',
  /**核心企业/客户企业/资方企业/开具方/最终付款方/接收方 [14位汉字长度]*/
  ENTNAME: '238px',
  /**手机号码 [11位数字] */
  PHONE: '141px',
  /**身份证号码 [18位数字或17位数字+1字母] */
  IDCARD: '228px',
  /**统一社会信用代码 [18位数字] */
  USCCNO: '204px',
  /**银行卡号 [19位数字] */
  BANKNO: '213px',
  /**联行号 [12位数字] */
  BRANCHNO: '150px',
  /**时间间隔:时分秒 */
  TIMESPAN_HMS: '98px',
  /**时间间隔:年月日 */
  TIMESPAN_YMD: '88px',
  /**可能大金额范围(本金、总额等) [千万位，两位小数点；带千分符；对齐方式为右对齐]*/
  AMOUNT_LONG: '144px',
  /**可能大金额范围(本金、总额等) [百万位，两位小数点；带千分符；对齐方式为右对齐]*/
  AMOUNT_SHORT: '135px',
  /**日利率 小数点后8位 [保留小数点后10位（等于带%好显示下小数点后8位）]*/
  RATE_LONG: '141px',
  /**年利率/折价率 [保留小数点后4位（等于带%好显示下小数点后2位）]*/
  RATE_SHORT: '87px',
  /**名称 [6位汉字] */
  PRODUCTNAME: '126',
  /**名称+CODE [6位汉字产品名称+5位数字/字母编号，中间用“-”链接] */
  PRODUCTNAMEANDCODE: '176',
  /**融资状态 [最大4个汉字] */
  ENUM_4: '98px',
  /**还款方式 [最大8个汉字] */
  ENUM_8: '154px',
  /**备注 */
  REMARK: '238px',
  /** 用户ID	U1234567	8位：U+7位*/
  USERID: '120px',
  /**ERP-ID/角色编号/	ASDFG12345QWERT67890	10位, 大小写字母+数字 */
  ERPID: '192px',
  /**合同名称	京东科技供应链金融服务主合同	14个汉字 */
  CONTRACT: '238px',
  /**角色名称	单个角色名称	4个汉字 */
  ROLE_SINGLE: '98px',
  /**角色名称	多个角色名称，融资客户、供应商、核心企业	10个汉字 */
  ROLE_MUTI: '182px',
  /**银行/开户银行	中国邮政储蓄银行	8个汉字 */
  BANK: '154px',
  /**开户支行	中国邮政储蓄银行知春南路支行	14个汉字 */
  BRANCH: '238px',
  /**银行+卡号	中国邮政储蓄银行-4856	8个汉字+4位数字(银行卡尾号)，中间用“-”链接 */
  BANKANDCODE: '190px',
  /**业务模式	信用流转	4位 */
  BIZTYPE: '98px',
  /**中文字数，用作标题 */
  ...new Array(20).fill(1, 0, 20).reduce((prev, curr, idx) => {
    prev[`CHN_${idx + 1}`] = `${(idx + 1) * 14 + 42}px`
    return prev
  }, {}),
}
